module.exports = __webpack_public_path__ + "img/9_80.502308e0.png";